import { render, staticRenderFns } from "./mapThaigis.vue?vue&type=template&id=4db078bc&scoped=true&"
import script from "./mapThaigis.vue?vue&type=script&lang=js&"
export * from "./mapThaigis.vue?vue&type=script&lang=js&"
import style0 from "./mapThaigis.vue?vue&type=style&index=0&id=4db078bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db078bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
